import React, { useState, useEffect } from "react";
import {
	Box,
	Button,
	Heading,
	Divider,
	NumberInput,
	NumberInputField,
	Table,
	Thead,
	Tbody,
	Tr,
	Th,
	Td,
	Input,
	HStack,
} from "@chakra-ui/react";

export default function LineChartDataEditor({ onDataChange, isEn = true, onSave, initData }) {
	const [data, setData] = useState(null);

	useEffect(() => {
		setData(initData?.data);
	}, []);

	if (!data) return <div>Loading...</div>;

	const handleValueChange = (datasetIndex, valueIndex, valString, valNumber) => {
		const updated = { ...data };
		// save as string so user can type "0." or "0.5"
		updated.datasets[datasetIndex].data[valueIndex] = valString;
		// if it's a valid number, also commit numeric form
		if (!isNaN(valNumber)) {
			updated.datasets[datasetIndex].data[valueIndex] = valNumber;
		}
		setData(updated);
		onDataChange?.(updated);
	};


	const handleAddYear = () => {
		const newYear = String(Number(data.labels[data.labels.length - 1]) + 1);
		const updated = { ...data };
		updated.labels.push(newYear);
		updated.datasets.forEach((ds) => ds.data.push(0));
		setData(updated);
		onDataChange?.(updated);
	};

	const handleRemoveYear = (index) => {
		const updated = { ...data };
		updated.labels.splice(index, 1);
		updated.datasets.forEach((ds) => ds.data.splice(index, 1));
		setData(updated);
		onDataChange?.(updated);
	};

	const handleLabelChange = (index, newLabel) => {
		const updated = { ...data };
		updated.labels[index] = newLabel;
		setData(updated);
		onDataChange?.(updated);
	};

	return (
		<Box p={5} borderWidth="1px" borderRadius="lg" bg="white">
			<Heading size="md" mb={4}>
				Edit Line Chart Data
			</Heading>

			<Box overflowX="auto" maxW="100%">
				<Table size="sm" minW="800px">
					<Thead>
						<Tr>
							<Th>Dataset</Th>
							{data.labels.map((label, i) => (
								<Th key={i}>
									<HStack>
										<Input
											w="90px"
											value={label}
											size="sm"
											onChange={(e) => handleLabelChange(i, e.target.value)}
										/>
										<Button
											size="xs"
											colorScheme="red"
											onClick={() => handleRemoveYear(i)}
										>
											✕
										</Button>
									</HStack>
								</Th>
							))}
							<Th>
								
							</Th>
						</Tr>
					</Thead>
					<Tbody>
						{data.datasets.map((dataset, datasetIndex) => (
							<Tr key={datasetIndex}>
								<Td>{dataset.label}</Td>
								{dataset.data.map((value, valueIndex) => (
									<Td key={valueIndex}>
										<NumberInput
											value={value?.toString() ?? ""}
											step={0.01}
											precision={2}
											onChange={(valString, valNumber) =>
												handleValueChange(datasetIndex, valueIndex, valString) // keep string
											}
											size="sm"
											w="90px"
										>
											<NumberInputField inputMode="decimal" />
										</NumberInput>
									</Td>
								))}
							</Tr>
						))}
					</Tbody>
				</Table>
			</Box>

			<Button size="sm" mt="4" colorScheme="green" onClick={handleAddYear}>
				+ Add Year
			</Button>
			<Divider my={4} />

			<Button
				colorScheme="blue"
				onClick={() => {
					console.log("Updated line chart data:", data);
					onDataChange?.(data);
					onSave(data)
				}}
			>
				Save Changes
			</Button>
		</Box>
	);
}
